import React from 'react';
import './Footer.scss';

const Footer = () => {
  return (
    <footer>
      <div className="footer-inner max-width">

        {/* Brand */}
        <div className="footer-brand">
          <h3>Zorand</h3>
          <p>Elevating brands through innovative digital marketing strategies.</p>
        </div>

        {/* Services */}
        <div>
          <h4>Services</h4>
          <ul>
            <li><a href="#services">SEO</a></li>
            <li><a href="#services">Social Media</a></li>
            <li><a href="#services">Google Ads Specialist</a></li>
            <li><a href="#services">Content</a></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4>Company</h4>
          <ul>
            <li><a href="/">About</a></li>
            <li><a href="/">Careers</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4>Legal</h4>
          <ul>
            <li><a href="/">Privacy</a></li>
            <li><a href="/">Terms</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4>Contact</h4>
          <div className="footer-contact-list">
            <a className="footer-contact-link" href="tel:+918341062346">
              <span className="footer-contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.81a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </span>
              +91 8341062346
            </a>
            <a className="footer-contact-link" href="mailto:info@zorand.in">
              <span className="footer-contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="16" x="2" y="4" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
              </span>
              info@zorand.in
            </a>
          </div>
        </div>

        {/* Partners */}
        <div className="partner-section">
          <h4>Partners</h4>
          <a
            className="partner-logo-wrap"
            href="https://www.google.com/partners/agency?id=6312390294"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/google-partner.png"
              alt="Google Partner"
              className="partner-logo"
            />
          </a>
        </div>

      </div>

      <div className="footer-bottom max-width">
        <small>© 2025 Zorand. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
